import { currentUserQuery } from "@common/api/users"
import { useCreateWorkPackagePhaseMutation } from "@common/api/work-package-phases"
import { hasPermission } from "@common/lib/permissions"
import { handleError } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import { PhaseNameDialog } from "@/components/phase/phase-name-dialog"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/work-orders/$workOrderId/phases/new",
)({
  beforeLoad: async ({ context: { queryClient }, params, search }) => {
    const me = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(me, "work_package:update")) {
      throw redirect({ to: "/work-orders/$workOrderId", params, search })
    }
  },
  component: NewPhaseDialog,
})

function NewPhaseDialog(): React.ReactElement {
  const { workOrderId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const mutation = useCreateWorkPackagePhaseMutation()
  const close = () =>
    navigate({
      to: "/work-orders/$workOrderId",
      params: { workOrderId },
      search: true,
    })

  return (
    <PhaseNameDialog
      title="New phase"
      description="Group this work order's tasks by check, such as an A-check or a C-check."
      name=""
      action="Create phase"
      pending={mutation.isPending}
      onSave={(name) =>
        mutation.mutate(
          { work_package_id: workOrderId, workPackagePhaseCreate: { name } },
          {
            onSuccess: (phase) => {
              showToast("Created", `${phase.name} added.`, "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
      onCancel={close}
    />
  )
}
